import { useBrand } from '@cof/plastic-components';

import { useFormData } from '../../components/FormDataContext';
import partners from '../../partners';

const PTD_VENDOR_CODE = 'PTD';

const useIsPtd = () => {
    const brand = useBrand();
    const { vendorCode } = useFormData();
    return vendorCode === PTD_VENDOR_CODE && brand === partners.CAPITAL_ONE;
};

export default useIsPtd;
